import axios from "axios";
import { getDataContext, SubjectUserResponse, SubjectTeamResponse } from "./process-prompt-vars";
import { ShortOrganisationDetailsApiModel, TeamApiModel } from "../../api-models";

export const DataSubjects = {
  USER: "User",
  TEAM: "Team",
  ORG: "Org",
} as const;

export type DataSubject = (typeof DataSubjects)[keyof typeof DataSubjects];

export type SubjectType = "subject-user" | "subject-team" | "subject-org";

async function getSubjectByType(subjectType: DataSubject, subjectId: string) {
  const urlSubjectType = subjectType.charAt(0).toLowerCase() + subjectType.slice(1);

  const url = `/api/subject${urlSubjectType}/${subjectId}`;

  switch (subjectType) {
    case DataSubjects.ORG:
      return (await axios.get<ShortOrganisationDetailsApiModel>(url)).data;
    case DataSubjects.TEAM:
      return (await axios.get<SubjectTeamResponse>(url)).data;
    default:
      return (await axios.get<SubjectUserResponse>(url)).data;
  }
}

export async function getDataContextWithSubject(
  subjectType: DataSubject,
  subjectId: string,
): Promise<ReturnType<typeof getDataContext>> {
  const subjectApiModel = await getSubjectByType(subjectType, subjectId);
  const key = `subject${subjectType}`;

  return getDataContext({ [`${key}`]: subjectApiModel });
}

export function getTypeFromParam(param: string): DataSubject | undefined {
  switch (param) {
    case "User":
      return DataSubjects.USER;
    case "Team":
      return DataSubjects.TEAM;
    case "Org":
      return DataSubjects.ORG;
    default:
      return undefined;
  }
}
